import { Link } from "react-router-dom";
import SocialLinks from "./SocialLinks";
import { seoConfig } from "../data/seoConfig";
import { brandIdentity } from "../data/brand";
import { getRenderDate } from "../utils/renderClock";

const exploreLinks = [
  ["Humanoid robots", "/humanoid-robots"], ["Robotics news", "/robotics-news"],
  ["Physical AI", "/physical-ai"], ["Companies", "/robotics-companies"],
  ["Events", "/robotics-events"], ["AI guides", "/ai"],
];
const resourceLinks = [
  ["Robot categories", "/robotics-topics"], ["Robot components", "/robot-components"],
  ["Robotics software", "/robotics-software"], ["Robot sensors", "/robot-sensors"],
  ["Data and comparisons", "/data"], ["Jobs", "/jobs"],
];
const companyLinks = [
  ["About TechniaHQRobot", "/about-techniahq"], ["Contact", "/contact"],
  ["Editorial and corrections policy", "/editorial-policy"],
  ["Advertise", "/advertise"], ["Partnerships", "/partnerships"],
];
const legalLinks = [
  ["Privacy policy", "/privacy-policy"], ["Terms of use", "/terms-of-use"],
  ["Cookie policy", "/cookie-policy"], ["HTML sitemap", "/sitemap.html"],
  ["XML sitemap", "/sitemap.xml"],
];

function LinkList({ title, links }) {
  return (
    <div>
      <h2 className="text-xs font-black uppercase tracking-[0.18em] text-cyan-200/80">{title}</h2>
      <div className="mt-4 grid gap-3 text-sm text-neutral-300">
        {links.map(([label, href]) => (
          href.endsWith(".xml") || href.endsWith(".html") ? (
            <a key={href} href={href} className="w-fit font-semibold transition hover:text-white">
              {label}
            </a>
          ) : (
            <Link key={href} to={href} className="w-fit font-semibold transition hover:text-white">
              {label}
            </Link>
          )
        ))}
      </div>
    </div>
  );
}

export default function Footer() {
  return (
    <footer lang="en" className="site-wide-section mt-20 pb-6">
      <div className="site-wide-frame overflow-hidden border border-white/10 bg-neutral-950 text-white shadow-[0_30px_100px_rgba(15,23,42,0.24)]">
        <div className="px-5 py-10 sm:px-8 lg:px-10 lg:py-12">
          <div className="grid gap-8 xl:grid-cols-[minmax(280px,0.85fr)_minmax(0,2.15fr)] xl:items-start xl:gap-10">
            <div>
              <Link to="/" className="inline-flex items-center gap-3 rounded-full">
                <span className="grid h-10 w-10 place-items-center rounded-2xl border border-white/10 bg-gradient-to-br from-white via-blue-100 to-cyan-200 text-sm font-black text-neutral-950 shadow-[0_18px_44px_rgba(6,182,212,0.18)]">T</span>
                <span>
                  <span className="block whitespace-nowrap text-lg font-black tracking-tight">TechniaHQRobot</span>
                  <span className="block whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.18em] text-neutral-400">Humanoid Robots &amp; Physical AI</span>
                </span>
              </Link>
              <p className="mt-5 max-w-md text-sm leading-7 text-neutral-300">
                {brandIdentity.description}
              </p>
              <div className="mt-5 grid gap-2 text-sm font-bold text-cyan-100">
                <a className="w-fit whitespace-nowrap underline underline-offset-4 transition hover:text-white" href={`mailto:${seoConfig.email}`}>
                  {seoConfig.email}
                </a>
              </div>
            </div>

            <div className="min-w-0">
              <h2 className="text-xs font-black uppercase tracking-[0.18em] text-cyan-200/80">Follow TechniaHQRobot</h2>
              <p className="mt-4 text-sm leading-7 text-neutral-300">
                Follow the official TechniaHQRobot accounts for robotics news, humanoid robots, Physical AI, research, companies and event coverage.
              </p>
              <SocialLinks variant="footer" className="mt-5" primaryOnly />
            </div>
          </div>

          <div className="mt-10 grid gap-8 border-t border-white/10 pt-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-10">
            <LinkList title="Explore" links={exploreLinks} />
            <LinkList title="Resources" links={resourceLinks} />
            <LinkList title="Publication" links={companyLinks} />
            <LinkList title="Policies" links={legalLinks} />
          </div>


        </div>
        <div className="border-t border-white/10 px-5 py-5 text-center text-xs text-neutral-400 sm:px-8">
          © {getRenderDate().getFullYear()} TechniaHQRobot. Independent robotics media and technical analysis.
        </div>
      </div>
    </footer>
  );
}
